<template>
  <v-btn
    class="mbtn font-weight-regular"
    prepend-icon="ct:arrow-left"
    @click="appraisalBuyoutStep -= 1"
  >
    {{ t("buyout.appraisal.go_back") }}
  </v-btn>
  <div class="app__title app__title--h3">
    {{ `${ authStore.isPartner ? t("buyout.appraisal.specify_customers_device") : t("buyout.appraisal.specify_your")} ${selectedMetaMaster?.name} ${isNewDeviceProcess ? t("static.banners.for_buyout") : ''}` }}
  </div>
  <div class="buyout__detail">
    <img :src="buildImageUrl(selectedProductColor?.image ?? selectedMetaMaster?.image ?? '')" class="img-responsive">
    <div class="wrapper">
      <v-progress-circular v-if="loadingAvailableProductVariants" />
      <client-only v-else>
        <div class="app__label color--grayTone3">
          {{ availableProductVariants?.device_attr_name?.name }}
        </div>
        <div
          v-if="availableProductVariants?.attr_values"
          class="bVariant"
        >
          <div
            v-for="variant in sortedAttrValues"
            :key="variant.id"
            :class="['bVariant__item', variant === selectedProductVariant ? 'is-selected': '', 'cursor-pointer']"
            @click="buyoutStore.selectProductVariant(variant, isNewDeviceProcess); useGoTo('#anchor_color', { offset: -150 });"
          >
            {{ variant.attribute_choice.value }}
          </div>
        </div>
        <div
          v-if="!loadingAvailableProductVariants && selectedProductVariant"
          id="anchor_color"
          class="app__label color--grayTone3"
        >
          {{ t("buyout.appraisal.color") }}
        </div>
        <v-progress-circular v-if="loadingAvailableProductColors" />
        <div class="bVariant bVariant--color text-center">
          <div
            v-for="colorVariant in availableProductColors"
            :key="colorVariant.id"
            :class="['bVariant__item', colorVariant.id === selectedProductColor?.id ? 'is-selected' : '', 'cursor-pointer']"
            @click="buyoutStore.selectProductColor(colorVariant, props.isNewDeviceProcess)"
          >
            <img :src="buildImageUrl(colorVariant?.image)" class="img-responsive">
            <div class="first-letter-uppercase">
              {{ colorVariant.color.name }}
            </div>
          </div>
        </div>
        <v-btn
          class="mbtn mbtn--green"
          size="x-large"
          :disabled="!selectedProductColor || !selectedProductVariant"
          @click="appraisalBuyoutStep += 1"
        >
          {{ t("buyout.appraisal.continue") }}
        </v-btn>
      </client-only>
      <buyout-send-email-window v-if="!isNewDeviceProcess" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { orderBy } from "lodash-es";
import useGoTo from "cashtec-common/src/composables/useGoTo";

const buyoutStore = useBuyoutStore();
const authStore = useAuthStore();
const { buildImageUrl } = useUtils();
const { t } = useI18n();

const props = withDefaults(defineProps<{
  isNewDeviceProcess?: boolean
}>(), {
  isNewDeviceProcess: false
});

const {
  selectedProductVariant,
  selectedProductColor,
  selectedMetaMaster,
  appraisalBuyoutStep,
  availableProductVariants,
  availableProductColors,
  loadingAvailableProductVariants,
  loadingAvailableProductColors
} = storeToRefs(buyoutStore);

if (!availableProductVariants?.value?.attr_values) {
  buyoutStore.loadAvailableProductVariants();
}

const sortedAttrValues = computed<BuyoutDeviceAttributeValue[]>(() => {
  if (!availableProductVariants?.value?.attr_values?.length) { return []; }

  return orderBy(
    availableProductVariants.value.attr_values,
    [attrValue => (parseInt(attrValue.attribute_choice.value.split(" ")[0]))],
    "asc"
  );
});

</script>
